import { SHOPIFY_URL } from "../../utils/shopify.utils";
import { Button } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/styles";

const ShopNowButton = ({ className, margin = "" }) => {
  const theme = useTheme();
  const onClick = () =>
    (window.top.location.href = SHOPIFY_URL + "collections/all");

  const style = {
    color: theme.COLORS.BLUE.darkBlueGreen,
    textDecoration: "underline",
    fontSize: "0.7rem",
    position: "absolute",
    whiteSpace: "nowrap",
    zIndex: 3000,
    margin,
  };
  return (
    <Button style={style} onClick={onClick} className={className}>
      Shop Now
    </Button>
  );
};

export default ShopNowButton;
